import { render, staticRenderFns } from "./addMainCategoryProduct.vue?vue&type=template&id=4af6dea2&scoped=true"
import script from "./addMainCategoryProduct.vue?vue&type=script&lang=js"
export * from "./addMainCategoryProduct.vue?vue&type=script&lang=js"
import style0 from "./addMainCategoryProduct.vue?vue&type=style&index=0&id=4af6dea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6dea2",
  null
  
)

export default component.exports